export const invoicesEn = {
  // BEGIN Michael
  CLIENT: 'Client',
  BROKER: 'Broker',
  INVOICE: 'Invoice',
  INVOICES: 'Invoices',

  PEDNING_INVOICES: 'Pending Invoices',

  DRAFTS: 'Drafts',
  DRAFT_INVOICES: 'Draft Invoices',

  APPROVED_FOR_FUNDING_INVOICES: 'Approved for Funding Invoices',

  FUNDED: 'Funded',
  FUNDED_INVOICES: 'Funded Invoices',
  FUNDED_DATE: 'Funded Date',

  PAID: 'Paid',
  PAID_INVOICES: 'Paid Invoices',
  PAID_DATE: 'Paid Date',

  OPEN_INVOICES: 'Open Invoices',
  CLOSE_INVOICES: 'Closed Invoices',

  INVOICE_DATE: 'Invoice Date',
  INVOICE_NUMBER: 'Invoice Number',
  REFERENCE_NUMBER: 'Reference Number',

  INVOICE_SUBMITTED_SUCCESS: 'Invoice Submitted Successfully!',

  DELETE_DRAFT_INVOICES: 'Delete Draft Invoices',
  DRAFT_INVOICES_DELETED: 'Draft Invoices Deleted Successfully!',
  INVALID_IDS: 'Invalid Draft IDs, please try again.',
  DUE_DATE: 'Due Date',
  DUE_DATE_CALCULATE_INFO: 'If left blank, due date will be calculated from Payment Term',
  // END Michael
  CREATE_INVOICE: 'Create Invoice',
  REFERENCE: 'Reference',
  NOTES: 'Notes',
  UPLOAD_DOCUMENTS: 'Upload Documents',
  DOCUMENTS_ADDED_INVOICE: 'All documents were successfully added to the invoice',
  INVOICE_CREATED_SUCCESSFULLY: 'Invoice created successfully',
  CREATE_WARNING:
    'By clicking the "Create" button, you will send the invoice information to the factor. ' +
    'Please ensure that all invoice details are correct before proceeding. This action cannot be undone.',
  INVALID_INVOICE_AMOUNT:
    'Enter a positive amount with up to 17 digits before and 2 digits after the decimal. ' +
    'Maximum allowed is 999,999,999,999,999,999.99.',
  VENDOR: 'Vendor',
  VENDOR_PAYMENT: 'Vendor Payment Amount',
  VENDOR_INVOICE_ID: 'Vendor Invoice ID',
  PAYMENT_DATE: 'Payment Date',

  //BEGIN Patricio
  PENDING: {
    SINGLE: 'Pending',
    PLURAL: 'Pending',
  },

  APPROVED_FOR_FUNDING: {
    SINGLE: 'Approved for Funding',
    PLURAL: 'Approved for Funding',
  },

  REJECTED_INVOICES: 'Rejected Invoices',
  INFORMATION: 'Information',
  AMOUNT_DETAILS: 'Amount Details',
  CREATED_ON: 'Created On',
  DAYS_AGED: 'Days Aged',
  DAYS_OUTSTANDING: 'Days Outstanding',
  INVOICE_STATUS: 'Invoice Status',
  PAYMENT_STATUS: 'Payment Status',
  PAYMENT_STATUS_INFO:
    'This can be OPEN or CLOSED. Closed means it has been paid off, in any other case it will be open.',
  PAID_ON: 'Paid On',
  PAYMENT_TRANSACTION_NUMBER: 'Payment Transaction Number',
  NON_FACTORED_INVOICE: 'Nonfactored Invoice',
  CLOSED_DATE: 'Closed Date',
  INVOICE_AMOUNT: 'Invoice Amount',
  INVOICE_BALANCE: 'Invoice Balance',
  ADVANCE_AMOUNT: 'Advance Amount',
  ESCROW_RESERVE_AMOUNT: 'Escrow Reserve Amount',
  CASH_RESERVE_AMOUNT: 'Cash Reserve Amount',
  PURCHASE_FEE_AMOUNT: 'Purchase Fee Amount',
  AUTOGENERATED_DOCUMENT_MSG: 'This document was autogenerated by the system.',

  EXPORT_INVOICES: 'Export Invoices',
  EXPORT_INVOICES_SUCCESSFULLY: 'Invoices exported successfully',
  ARE_YOU_SURE_EXPORT_INVOICES: 'Are you sure you want to export the invoices?',

  //END Patricio
}

export const invoicesEs: typeof invoicesEn = {
  // BEGIN Michael
  CLIENT: 'Cliente',
  BROKER: 'Corredor',
  INVOICE: 'Factura',
  INVOICES: 'Facturas',

  PEDNING_INVOICES: 'Facturas Pendientes',

  DRAFTS: 'Borradores',
  DRAFT_INVOICES: 'Borradores de Facturas',

  APPROVED_FOR_FUNDING_INVOICES: 'Facturas Aprobadas para Financiamiento',

  FUNDED: 'Financiado',
  FUNDED_INVOICES: 'Facturas Financiadas',
  FUNDED_DATE: 'Fecha de Financiamiento',

  PAID: 'Pagado',
  PAID_INVOICES: 'Facturas Pagadas',
  PAID_DATE: 'Fecha de Pago',

  OPEN_INVOICES: 'Facturas Abiertas',
  CLOSE_INVOICES: 'Facturas Cerradas',

  INVOICE_DATE: 'Fecha de Factura',
  INVOICE_NUMBER: 'Número de Factura',
  REFERENCE_NUMBER: 'Número de Referencia',

  INVOICE_SUBMITTED_SUCCESS: '¡Factura Enviada Exitosamente!',

  DELETE_DRAFT_INVOICES: 'Eliminar Borradores',
  DRAFT_INVOICES_DELETED: '¡Borradores Eliminados Exitosamente!',
  INVALID_IDS: 'IDs de borrador no válidos, por favor inténtelo de nuevo.',
  DUE_DATE: 'Fecha de Vencimiento',
  DUE_DATE_CALCULATE_INFO: 'Si se deja en blanco, la fecha de vencimiento se calculará a partir del Término de Pago',
  // END Michael
  CREATE_INVOICE: 'Crear Factura',
  REFERENCE: 'Referencia',
  NOTES: 'Notas',
  UPLOAD_DOCUMENTS: 'Subir documentos',
  DOCUMENTS_ADDED_INVOICE: 'Todos los documentos han sido añadidos a la Factura.',
  INVOICE_CREATED_SUCCESSFULLY: 'Factura creada exitosamente',
  CREATE_WARNING:
    'Al hacer clic en el botón "Crear", enviará la información de la factura al factor. ' +
    'Por favor, asegúrese de que todos los detalles de la factura son correctos antes de continuar. Esta acción no se puede deshacer.',
  INVALID_INVOICE_AMOUNT:
    'Ingrese un monto positivo con hasta 17 dígitos antes y 2 dígitos después del decimal. ' +
    'El máximo permitido es 999,999,999,999,999,999.99.',

  VENDOR: 'Proveedor',
  VENDOR_PAYMENT: 'Monto de Pago del Proveedor',
  VENDOR_INVOICE_ID: 'ID de Factura del Proveedor',
  PAYMENT_DATE: 'Fecha de pago',

  //BEGIN Patricio
  PENDING: {
    SINGLE: 'Pending',
    PLURAL: 'Pending',
  },

  APPROVED_FOR_FUNDING: {
    SINGLE: 'Approved for Funding',
    PLURAL: 'Approved for Funding',
  },

  REJECTED_INVOICES: 'Facturas Rechazadas',
  INFORMATION: 'Información',
  AMOUNT_DETAILS: 'Detalles de Monto',
  CREATED_ON: 'Creado el',
  DAYS_AGED: 'Días de Antigüedad',
  DAYS_OUTSTANDING: 'Días Pendientes',
  INVOICE_STATUS: 'Estado de la Factura',
  PAYMENT_STATUS: 'Estado de pago',
  PAYMENT_STATUS_INFO:
    'Esto puede ser ABIERTO o CERRADO. Cerrado significa que ha sido pagado, en cualquier otro caso estará abierto.',
  PAID_ON: 'Paid On',
  PAYMENT_TRANSACTION_NUMBER: 'Número de transacción de pago',
  NON_FACTORED_INVOICE: 'Factura no factorizada',
  CLOSED_DATE: 'Fecha de cierre',
  INVOICE_AMOUNT: 'Monto de la factura',
  INVOICE_BALANCE: 'Saldo de la factura',
  ADVANCE_AMOUNT: 'Monto de adelanto',
  ESCROW_RESERVE_AMOUNT: 'Monto de reserva de garantía',
  CASH_RESERVE_AMOUNT: 'Monto de reserva de efectivo',
  PURCHASE_FEE_AMOUNT: 'Monto de la tarifa de compra',
  AUTOGENERATED_DOCUMENT_MSG: 'Este documento fue generado automáticamente por el sistema.',

  EXPORT_INVOICES: 'Exportar Facturas',
  EXPORT_INVOICES_SUCCESSFULLY: 'Facturas exportadas exitosamente',
  ARE_YOU_SURE_EXPORT_INVOICES: '¿Está seguro de que desea exportar las facturas?',

  //END Patricio
}
